'use strict';

exports.__esModule = true;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _pageActions = require('../actions/page-actions');

var _pageActions2 = _interopRequireDefault(_pageActions);

var _profileRightSection = require('../actions/profile-right-section');

var _profileRightSection2 = _interopRequireDefault(_profileRightSection);

var _bookAppointmentSection = require('../actions/book-appointment-section');

var _bookAppointmentSection2 = _interopRequireDefault(_bookAppointmentSection);

var _requestAppointmentModal = require('../actions/request-appointment-modal');

var _requestAppointmentModal2 = _interopRequireDefault(_requestAppointmentModal);

var _somethingWentWrongModal = require('../actions/something-went-wrong-modal');

var _somethingWentWrongModal2 = _interopRequireDefault(_somethingWentWrongModal);

var _bookAppointmentModal = require('../actions/book-appointment-modal');

var _bookAppointmentModal2 = _interopRequireDefault(_bookAppointmentModal);

var _telephoneModal = require('../actions/telephone-modal');

var _telephoneModal2 = _interopRequireDefault(_telephoneModal);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reduxSimpleAuth = require('redux-simple-auth');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactIntl = require('react-intl');

var _headHelmet = require('../../../head-helmet');

var _schemaGenerator = require('schema-generator');

var _loadingDots = require('loading-dots');

var _profileHeader = require('../../../profile-header');

var _bookAppointmentSection3 = require('../../../book-appointment-section');

var _profileRightSection3 = require('../../../profile-right-section');

var _doctifyGoogleMap = require('../../../doctify-google-map');

var _doctifyModals = require('../../../doctify-modals');

var _doctifyUtils = require('doctify-utils');

var _sanitizeHtml = require('sanitize-html');

var _sanitizeHtml2 = _interopRequireDefault(_sanitizeHtml);

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _specialistProfile = require('../transformers/specialist-profile');

var _loaders = require('../utils/loaders');

var _utils = require('../utils/utils');

var _constants = require('../utils/constants');

var _helpers = require('../../../../src/client/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 loaders
 **/
var globalActions = _doctifyGlobalRedux2.default.globalActions;
var ReviewModalActions = globalActions.ReviewModalActions,
    SignUpModalActions = globalActions.SignUpModalActions,
    ReportModalActions = globalActions.ReportModalActions;


var locale = 'en';

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);

var specialistPageLoader = new _doctifyUtils.PageLoader(_loaders.loaders);

var messages = void 0;
try {
  messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
  messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var GOOGLE_APPROX_MAX_DESCRIPTION_LENGTH = 157;
var MAX_MOBILE_WIDTH = 767;
var SCROLL_DELAY = 500;

var loadingAuthedReviews = false;

var displayPageOr404 = function displayPageOr404(props) {

  if (!props || !props.page) {
    return false;
  }

  var isInitLoaded = props.page && props.page.id;
  var account = props.session && props.session.account;
  var authToken = props.session && props.session.auth_token;
  var specialistError = props.page && props.page.specialistLoadError;
  var isInvalid = props.page && !['approved', 'verified'].includes(props.page.status);
  var pageIsNotOwned = props.page && !(0, _doctifyUtils.pageIsOwned)(props.session, props.page.id, 'specialist');
  var checkNotReady = !isInitLoaded || !props.isRestored;
  var notPresentedOnThisTenancy = !!props.page.isVitality === false || !!props.page.isVitalityOn === false;

  if (specialistError || !checkNotReady && (isInvalid && pageIsNotOwned || notPresentedOnThisTenancy)) {

    if (typeof window !== 'undefined') {
      var _errorMessage = 'Specialist ' + props.page.name + ' not found';

      if (isInvalid && pageIsNotOwned || notPresentedOnThisTenancy) {
        _errorMessage = 'This specialist is not available with the search terms you have specified. This may be because they are not on the hospital list you have selected. You may wish to search again, without entering a specific consultant’s name.';
      }

      window.location.href = '/404?errorMessage=' + encodeURIComponent(_errorMessage);
      return false;
    }
    return false;
  }

  if (checkNotReady) {
    return false;
  }

  return true;
};

var SpecialistPage = function SpecialistPage(props) {
  //eslint-disable-line
  props.init(props);
  if (props && props.isInitLoaded && props.session.auth_token && !loadingAuthedReviews && !props.page.hasReceivedAuthedReviews) {
    loadingAuthedReviews = true;
    props.pageActions.loadSpecialistReviews(props.params.id, 50, props.session.auth_token).then(function () {
      loadingAuthedReviews = false;
      props.pageActions.setHasReceivedAuthedReviews();
    });
  }

  var specialistInsurersIds = (props.insurers || []).map(function (insurer) {
    return insurer.id;
  });

  var hospitalListChoices = props.listings.insurers.filter(function (insurer) {
    return specialistInsurersIds.includes(insurer.id) || props.network;
  });
  if (hospitalListChoices.length < 4) {
    hospitalListChoices.push({
      id: _constants.I_CANT_SEE_MY_LIST_ID,
      name: 'I can’t see my list'
    });
  }

  var selectedHospitalList = props.hospitalList && hospitalListChoices.find(function (item) {
    return item.id === props.hospitalList;
  });
  if (selectedHospitalList) {
    selectedHospitalList = (0, _extends3.default)({}, selectedHospitalList, {
      shortName: (0, _utils.getInsurerAbbreviation)(selectedHospitalList.id, _constants.INSURERS_SHORT_NAME_DICTIONARY)
    });
  } else {
    selectedHospitalList = undefined;
  }

  var practicesWithLocations = (props.practices || []).filter(function (practice) {
    return practice && practice.location;
  }).filter(function (p) {
    return !!p;
  });

  var showRequestAppointment = props.page.isCore && props.page.hasRequestAppointment && props.requestAppointmentModal.practices && props.requestAppointmentModal.practices.length > 0;
  var showPhoneNumbers = (props.contactNumbers || []).length > 0;

  return _react2.default.createElement(
    _reactIntl.IntlProvider,
    { locale: localeBase, messages: messages },
    _react2.default.createElement(
      'div',
      { id: _style2.default.specialistPage },
      _react2.default.createElement(_headHelmet.HeadHelmet, {
        pageTitle: props.page.name + ', ' + props.page.specialty + ' ' + (practicesWithLocations.length > 0 && '- ' + practicesWithLocations[0].city + ' ' || ' ') + '| Doctify',
        pageContent: ('Book now with ' + props.page.name + '. Read patient reviews and make an appointment online, instantly. ' + (props.page.about && (0, _sanitizeHtml2.default)(props.page.about, { allowedTags: [] }))).substring(0, GOOGLE_APPROX_MAX_DESCRIPTION_LENGTH).concat('...'),
        pageImage: props.page.profileImage,
        pagePath: (0, _doctifyUtils.getResourcePath)('/specialist/' + props.page.loadedUri)
      }),
      _react2.default.createElement('div', { className: _style2.default.topNavBackground }),
      _react2.default.createElement(_schemaGenerator.SchemaPhysician, {
        specialistData: (0, _extends3.default)({}, props.page, { practices: practicesWithLocations }),
        specialistPracticesData: props.practices,
        reviewData: { reviews: props.reviews }
      }),
      displayPageOr404(props) && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: _style2.default.leftColumn },
          _react2.default.createElement(_profileHeader.SpecialistProfileHeader, (0, _extends3.default)({}, props.page, {
            totalReviews: props.number_of_reviews || 0,
            onStarsClick: props.scrollToReviews,
            onAddReview: props.reviewModalActions.openReviewModal,
            onShowPhoneNumbers: showPhoneNumbers ? function () {
              props.telephoneModalActions.openModal();
              props.telephoneModalActions.makeContactRequest({
                id: props.page.id,
                request_type: 'phone',
                source: window.innerWidth > MAX_MOBILE_WIDTH ? 'Desktop' : 'Mobile',
                source_application: 'website',
                network: props.network,
                phone: props.contactNumbers.map(function (n) {
                  return n.number;
                }).toString()
              });
            } : null,
            onRequestAppointment: showRequestAppointment ? function () {
              props.requestAppointmentModalActions.openRequestAppointmentModal(props.accountProfileData);
            } : null,
            requestAppointmentPractices: props.requestAppointmentModal.practices
          })),
          (props.page.isBmi || props.page.isRamsay || props.page.isSpire || props.page.isNuffield) && _react2.default.createElement(_bookAppointmentSection3.BookAppointmentSection, (0, _extends3.default)({}, props.page, props.bookAppointmentSection, props.bookAppointmentSectionActions, {
            hasRequestAppointment: showRequestAppointment,
            onRequestAppointmentClick: function onRequestAppointmentClick() {
              props.requestAppointmentModalActions.openRequestAppointmentModal(props.accountProfileData);
            },
            onBmiRequestAppointmentClick: function onBmiRequestAppointmentClick(availability) {
              props.requestAppointmentModalActions.openBmiRequestAppointmentModal(props.accountProfileData, availability);
            },
            startDate: props.calendarStartDate,
            onNextButtonClick: function onNextButtonClick() {
              props.updateAvailabilities((0, _extends3.default)({}, props, {
                calendarStartDate: (0, _moment2.default)(props.calendarStartDate).add((0, _utils.getVisibleCalendarDays)(), 'd').startOf('day')
              }));
            },
            onPreviousButtonClick: function onPreviousButtonClick() {
              props.updateAvailabilities((0, _extends3.default)({}, props, {
                // Prevents the start date from being set to a day previous to today.
                calendarStartDate: (0, _moment2.default)(props.calendarStartDate).subtract((0, _utils.getVisibleCalendarDays)(), 'd').startOf('day')
              }), true);
            },
            onPracticeSelected: function onPracticeSelected(practice) {
              props.bookAppointmentSectionActions.onPracticeSelected(practice);
              props.pageActions.setNearestAvailability(null);
              props.updateAvailabilities((0, _extends3.default)({}, props, {
                selectedPractice: practice,
                nearestAvailability: null
              }));
            },
            onSlotClick: function onSlotClick(time, practice) {
              props.bookAppointmentModalActions.openBookAppointmentModal(time, practice);
            },
            onNearestAvailabilityClick: function onNearestAvailabilityClick(date) {
              props.pageActions.setNearestAvailability(null);
              props.updateAvailabilities((0, _extends3.default)({}, props, {
                calendarStartDate: (0, _moment2.default)(date),
                nearestAvailability: null
              }));
            },
            calendarColumnStyles: _style2.default.calendarColumn,
            calendarMobileStyles: _style2.default.calendarMobile,
            calendarTabletStyles: _style2.default.calendarTablet,
            calendarLaptopStyles: _style2.default.calendarLaptop
          })) || _react2.default.createElement(
            'div',
            { className: _style2.default.mapContainerNoBookingContainer },
            practicesWithLocations.length && _react2.default.createElement(
              'div',
              { className: _style2.default.mapContainerNoBooking },
              _react2.default.createElement(_doctifyGoogleMap.DoctifyGoogleMap, {
                showAllMarkers: true,
                markers: practicesWithLocations.map(function (practice) {
                  return {
                    position: {
                      lat: practice.location.lat,
                      lng: practice.location.lng
                    }
                  };
                }),
                iconUrl: (0, _doctifyUtils.getResourcePath)('/static/img/map-icons/practice.png'),
                defaultCenter: practicesWithLocations.length > 0 && practicesWithLocations[0].position,
                containerElementStyle: {
                  height: '100%',
                  width: '100%',
                  position: 'relative',
                  overflow: 'hidden'
                } })
            ) || _react2.default.createElement(
              'div',
              { className: _style2.default.bookingContainer },
              _react2.default.createElement(
                'div',
                { className: _style2.default.noBookingInfo },
                _react2.default.createElement(
                  'div',
                  { className: _style2.default.noBookingEnabled },
                  props.isCore ? 'This specialist does not have the booking calendar enabled.' : 'This specialist is not connected with any practices in our system.'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  props.isCore ? 'Please use the buttons above to request an appointment or book over the phone.' : 'Please use the button above to book over the phone'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: _style2.default.profileSection,
            style: { paddingTop: props.app.headerHeight }
          },
          _react2.default.createElement(_profileRightSection3.ProfileRightSection, (0, _extends3.default)({}, props.page, props.profileRightSection, props.profileRightSectionActions, {
            loadSpecialistReviews: function loadSpecialistReviews() {
              var countToLoad = props.reviews ? props.reviews.length + 50 : 50;
              props.pageActions.loadSpecialistReviews(props.params.id, countToLoad, props.session.auth_token);
            },
            scrollToPeerRecommendations: props.location && props.location.query && (props.location.query.scrollToPeerRecommendations === "true" || props.location.query.scrollToPeerRecommendations === true),
            practiceAddress: props.practices,
            insurers: props.listings && (0, _specialistProfile.transformInsurers)(props.listings.insurers, props.insurers),
            professionalRegistry: props.listings && props.listings.professionalBodies && (0, _specialistProfile.transformProfessionalBody)(props.listings.professionalBodies, props.page.professionalRegistry),
            headerClicked: _doctifyUtils.scrollTo,
            isLoggedIn: props.isAuthenticated,
            likeButtonClicked: function likeButtonClicked(isLiked, index) {
              if (props.isAuthenticated) {
                props.toggleLike({
                  id: props.reviews[index].id,
                  auth: props.session.auth_token,
                  author: props.session.account.id
                });
              }
            },
            reportReviewClicked: props.reportModalActions.openReportModal
          }))
        )
      ),
      !displayPageOr404(props) && _react2.default.createElement(_loadingDots.LoadingDots, { centered: true }),
      props.reportModal.isOpen && _react2.default.createElement(_doctifyModals.ReportModal, (0, _extends3.default)({}, props.reportModal, props.reportModalActions, {
        closeModal: props.reportModalActions.closeReportModal,
        sendReportModal: function sendReportModal(review) {
          var url = (0, _utils.getReviewReportUrl)(review);
          var data = {
            reson_for_flag: props.reportModal.reportText,
            reporting_email: props.reportModal.reportEmail
          };
          props.reportModalActions.sendReportModal(url, data);
        }
      })),
      props.requestAppointmentModal.isOpen && _react2.default.createElement(_doctifyModals.RequestAppointmentModal, (0, _extends3.default)({}, props.requestAppointmentModal, props.requestAppointmentModalActions, {
        specialistName: props.name,
        updateAvailabilities: function updateAvailabilities() {
          props.updateAvailabilities((0, _extends3.default)({}, props, {
            calendarStartDate: (0, _moment2.default)(),
            nearestAvailability: null
          }));
        },
        network: props.network,
        patient: props.accountProfileData && props.accountProfileData.patient,
        account: props.accountProfileData
      })),
      props.contactNumbers && props.telephoneModal.isOpen && _react2.default.createElement(_doctifyModals.TelephoneModal, {
        numbers: props.contactNumbers,
        closeModal: props.telephoneModalActions.closeModal
      }),
      props.bookAppointmentModal.isOpen && !props.signUpModal.isOpen && _react2.default.createElement(_doctifyModals.BookAppointmentModal, (0, _extends3.default)({}, props.bookAppointmentModal, props.bookAppointmentModalActions, {
        insurers: props.insurers,
        loginOnSubmit: props.loginOnSubmit,
        submitAppointmentRequest: function submitAppointmentRequest(requestData) {
          // The || is part of the janky hack for book appt sign up flow. See also book appt modal, global redux, and sign up modal.
          return props.submitBooking(requestData, props.session.auth_token || props.signUpModal.bookingFlowAuthInfo.auth_token).then(function () {
            props.updateAvailabilities((0, _extends3.default)({}, props, {
              calendarStartDate: (0, _moment2.default)(),
              nearestAvailability: null
            }));
          });
        },
        showSignUp: props.showSignUp,
        account: props.accountProfileData,
        bookingFlowAuthInfo: props.signUpModal.bookingFlowAuthInfo,
        errorMessage: props.errorMessage
      })),
      props.somethingWentWrongModal.isOpen && _react2.default.createElement(_doctifyModals.SomethingWentWrongModal, {
        slotNotAvailable: props.somethingWentWrongModal.slotNotAvailable,
        closeModal: function closeModal() {
          props.somethingWentWrongModalActions.closeSomethingWentWrongModal();
        }
      }),
      props.isHospitalListModalOpen && _react2.default.createElement(_doctifyModals.HospitalListModal, {
        selectedHospitalList: selectedHospitalList,
        hospitalListChoices: hospitalListChoices,
        closeModal: function closeModal() {
          props.toggleHospitalListModal(false);
        },
        chooseHospitalList: function chooseHospitalList(hospitalList) {
          hospitalList = parseInt(hospitalList);
          var query = (0, _extends3.default)({}, props.location.query, {
            hospitalList: hospitalList
          });
          var search = (0, _helpers.queryObjectToQueryString)(query);
          var path = props.location.pathname + '?' + search;

          props.router.push(path);
          props.chooseHospitalList(hospitalList);
          // props.toggleHospitalListModal(false);
        }
      })
    )
  );
};

SpecialistPage.propTypes = {
  params: require('react').PropTypes.shape({
    id: require('react').PropTypes.any.isRequired
  }).isRequired,
  session: require('react').PropTypes.shape({
    auth_token: require('react').PropTypes.any.isRequired,
    selectedProfile: require('react').PropTypes.object.isRequired,
    profiles: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
    account: require('react').PropTypes.object.isRequired
  }).isRequired,
  topNav: require('react').PropTypes.shape({}).isRequired,
  reviewModal: require('react').PropTypes.shape({}).isRequired,
  reportModal: require('react').PropTypes.shape({
    isOpen: require('react').PropTypes.oneOf([false]).isRequired
  }).isRequired,
  page: require('react').PropTypes.shape({
    id: require('react').PropTypes.any.isRequired,
    status: require('react').PropTypes.any.isRequired,
    name: require('react').PropTypes.any.isRequired,
    specialty: require('react').PropTypes.any.isRequired,
    practices: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
    about: require('react').PropTypes.any.isRequired,
    profileImage: require('react').PropTypes.any.isRequired,
    hasReceivedAuthedReviews: require('react').PropTypes.any.isRequired,
    loadedUri: require('react').PropTypes.any.isRequired,
    professionalRegistry: require('react').PropTypes.any.isRequired,
    specialistLoadError: require('react').PropTypes.bool,
    isCore: require('react').PropTypes.any,
    isAHG: require('react').PropTypes.any,
    isBmi: require('react').PropTypes.any,
    isRamsay: require('react').PropTypes.any,
    isSpire: require('react').PropTypes.any,
    isNuffield: require('react').PropTypes.any,
    isDoctify: require('react').PropTypes.any,
    isVitality: require('react').PropTypes.any,
    isVitalityOn: require('react').PropTypes.any,
    networks: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired
  }).isRequired,
  listings: require('react').PropTypes.shape({
    insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
    professionalBodies: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired
  }).isRequired,
  profileRightSection: require('react').PropTypes.shape({}).isRequired,
  requestAppointmentModal: require('react').PropTypes.shape({
    isOpen: require('react').PropTypes.any.isRequired
  }).isRequired,
  bookAppointmentSection: require('react').PropTypes.shape({}).isRequired,
  bookAppointmentModal: require('react').PropTypes.shape({
    isOpen: require('react').PropTypes.any.isRequired
  }).isRequired,
  somethingWentWrongModal: require('react').PropTypes.shape({
    isOpen: require('react').PropTypes.any.isRequired
  }).isRequired,
  accountProfileData: require('react').PropTypes.shape({
    patient: require('react').PropTypes.object.isRequired
  }).isRequired,
  telephoneModal: require('react').PropTypes.shape({
    isOpen: require('react').PropTypes.any.isRequired
  }).isRequired,
  signUpModal: require('react').PropTypes.shape({
    isOpen: require('react').PropTypes.any.isRequired,
    bookingFlowAuthInfo: require('react').PropTypes.shape({
      auth_token: require('react').PropTypes.any.isRequired
    }).isRequired
  }).isRequired,
  name: require('react').PropTypes.any.isRequired,
  practices: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  reviews: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  contactNumbers: require('react').PropTypes.arrayOf(require('react').PropTypes.any).isRequired,
  hasRequestAppointment: require('react').PropTypes.any.isRequired,
  hasBooking: require('react').PropTypes.any.isRequired,
  insurers: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  errorMessage: require('react').PropTypes.any.isRequired,
  isCore: require('react').PropTypes.any.isRequired,
  availabilities: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  isAuthenticated: require('react').PropTypes.any.isRequired,
  isInitLoaded: require('react').PropTypes.any.isRequired,
  showSignUp: require('react').PropTypes.any.isRequired,
  pageActions: require('react').PropTypes.object.isRequired,
  sessionActions: require('react').PropTypes.object.isRequired,
  topNavActions: require('react').PropTypes.object.isRequired,
  reviewModalActions: require('react').PropTypes.object.isRequired,
  reportModalActions: require('react').PropTypes.object.isRequired,
  profileRightSectionActions: require('react').PropTypes.object.isRequired,
  requestAppointmentModalActions: require('react').PropTypes.object.isRequired,
  bookAppointmentModalActions: require('react').PropTypes.object.isRequired,
  bookAppointmentSectionActions: require('react').PropTypes.object.isRequired,
  telephoneModalActions: require('react').PropTypes.object.isRequired,
  calendarStartDate: require('react').PropTypes.object.isRequired,
  hospitalList: require('react').PropTypes.number,
  isHospitalListModalOpen: require('react').PropTypes.bool.isRequired,
  init: require('react').PropTypes.func.isRequired,
  loginOnSubmit: require('react').PropTypes.func.isRequired,
  scrollToReviews: require('react').PropTypes.func.isRequired,
  updateAvailabilities: require('react').PropTypes.func.isRequired,
  toggleLike: require('react').PropTypes.func.isRequired,
  createSubscription: require('react').PropTypes.func.isRequired,
  submitBooking: require('react').PropTypes.func.isRequired,
  toggleHospitalListModal: require('react').PropTypes.func.isRequired,
  chooseHospitalList: require('react').PropTypes.func.isRequired
};
SpecialistPage.displayName = 'SpecialistPage';

SpecialistPage.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
  var page = state.specialistPage.page;
  var global = state.global;

  return {
    reportModal: global.reportModal,
    loadedUri: page.loadedUri,
    isInitLoaded: page.isInitLoaded,
    page: state.specialistPage.page,
    isRestored: (0, _reduxSimpleAuth.getIsRestored)(state),
    session: (0, _reduxSimpleAuth.getSessionData)(state),
    isAuthenticated: (0, _reduxSimpleAuth.getIsAuthenticated)(state),
    topNav: state.global.topNav,
    reviewModal: state.global.reviewModal,
    signUpModal: state.global.signUpModal,
    profileRightSection: state.specialistPage.profileRightSection,
    bookAppointmentSection: state.specialistPage.bookAppointmentSection,
    requestAppointmentModal: state.specialistPage.requestAppointmentModal,
    bookAppointmentModal: state.specialistPage.bookAppointmentModal,
    somethingWentWrongModal: state.specialistPage.somethingWentWrongModal,
    telephoneModal: state.specialistPage.telephoneModal,
    patient: state.specialistPage.patient,
    testString: page.testString,
    name: state.specialistPage.page.name,
    about: page.about,
    education: page.education,
    procedures: page.procedures,
    aboutSectionExpanded: page.aboutSectionExpanded,
    proceduresSectionExpanded: page.proceduresSectionExpanded,
    reviews: page.reviews,
    number_of_reviews: page.number_of_reviews,
    averageRating: page.averageRating,
    aggregateReview: page.aggregateReview,
    peerRecommendations: page.peerRecommendations,
    consultationFees: page.consultationFees,
    practices: page.practices,
    specialInterests: page.specialInterests,
    specialty: page.specialty,
    specialtyIcon: page.specialtyIcon,
    profileImage: page.profileImage,
    qualifications: page.qualifications,
    hasRequestAppointment: page.hasRequestAppointment,
    hasBooking: page.hasBooking,
    insurers: page.insurers,
    professionalRegistry: page.professionalRegistry,
    listings: global.listings,
    subspecialties: page.subspecialties,
    articles: page.articles,
    availabilities: page.availabilities,
    calendarStartDate: page.calendarStartDate && (0, _moment2.default)(page.calendarStartDate) || (0, _moment2.default)().add(2, 'days'),
    nearestAvailability: page.nearestAvailability,
    latestAvailabilityFound: page.latestAvailabilityFound,
    activeView: page.activeView,
    contactNumbers: page.contactNumbers,
    selectedPractice: state.specialistPage.bookAppointmentSection.selectedPractice,
    accountProfileData: global.accountProfileData,
    isCore: page.isCore,
    isAHG: page.isAHG,
    isBmi: page.isBmi,
    isRamsay: page.isRamsay,
    isSpire: page.isSpire,
    isNuffield: page.isNuffield,
    hospitalList: page.hospitalList,
    isHospitalListModalOpen: page.isHospitalListModalOpen,
    network: page.network,
    app: global.app
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    pageActions: (0, _redux.bindActionCreators)(_pageActions2.default, dispatch),
    profileRightSectionActions: (0, _redux.bindActionCreators)(_profileRightSection2.default, dispatch),
    bookAppointmentSectionActions: (0, _redux.bindActionCreators)(_bookAppointmentSection2.default, dispatch),
    requestAppointmentModalActions: (0, _redux.bindActionCreators)(_requestAppointmentModal2.default, dispatch),
    somethingWentWrongModalActions: (0, _redux.bindActionCreators)(_somethingWentWrongModal2.default, dispatch),
    bookAppointmentModalActions: (0, _redux.bindActionCreators)(_bookAppointmentModal2.default, dispatch),
    telephoneModalActions: (0, _redux.bindActionCreators)(_telephoneModal2.default, dispatch),
    signUpModalActions: (0, _redux.bindActionCreators)(SignUpModalActions, dispatch),
    reviewModalActions: (0, _redux.bindActionCreators)(ReviewModalActions, dispatch),
    reportModalActions: (0, _redux.bindActionCreators)(ReportModalActions, dispatch),
    init: function init(props) {
      if (typeof window !== 'undefined') {
        specialistPageLoader.runOnce(dispatch, props, null, { _id_: props.params && props.params.id, _hospitalList_: props.location.query.hospitalList, _network_: props.location.query.network }).then(function (isFirstLoad) {
          if (isFirstLoad) {
            (0, _utils.attachCaptchaFlow)();
            props.pageActions.initLoaded();
            (0, _doctifyUtils.fireGTMevent)('specialist_page_view');
          } else if (props.isInitLoaded) {
            props.mapUrlToProps(props);
          }
        });
      }
    },
    mapUrlToProps: function mapUrlToProps(props) {
      if (props.params.id !== props.loadedUri) {
        var _hospitalList = parseInt(props.location.query.hospitalList, 10);
        _hospitalList = isNaN(_hospitalList) ? undefined : _hospitalList;
        var network = props.location.query.network;
        (0, _doctifyUtils.fireGTMevent)('specialist_page_view');
        props.pageActions.loadUri(props.params.id);
        props.pageActions.updateCalendarStartDate(_moment2.default.utc().add(2, 'days'));
        props.pageActions.trackViewsFromSearch(props.params.id);
        props.pageActions.loadSpecialistProfile(props.params.id, props.listings.specialties, _hospitalList, network).then(function (response) {
          props.pageActions.loadSpecialistAvailabilities(props.params.id, { startdate: (0, _moment2.default)().add(2, 'days').format('YYYY-MM-DD HH:mm') });
          if (response && response.specialist && response.specialist.author_id) {
            return props.pageActions.loadSpecialistBlogPosts(response.specialist.author_id);
          } else {
            return _promise2.default.resolve();
          }
        });
        props.pageActions.loadSpecialistReviews(props.params.id, 0, props.session.auth_token);
        props.pageActions.loadSpecialistAggregateReview(props.params.id, props.session.auth_token);
        props.pageActions.loadSpecialistPeerRecommendations(props.params.id);
      }
    },
    toggleLike: function toggleLike(payload) {
      dispatch(_pageActions2.default.toggleLike(payload));
    },
    updateAvailabilities: function updateAvailabilities(props, isPreviousDate) {
      // Prevents the start date from being set to any moment before the
      // current date and time.
      var startDate = _moment2.default.max((0, _moment2.default)(props && props.calendarStartDate), (0, _moment2.default)().add(2, 'days'));
      dispatch(_pageActions2.default.updateCalendarStartDate(startDate));

      var nearestAvailability = props && props.nearestAvailability;

      // Resets the nearest availability when it is before the current
      // week.
      if (nearestAvailability && (0, _moment2.default)(nearestAvailability).isBefore((0, _moment2.default)(startDate).add(_constants.LAPTOP_CALENDAR_DAYS, 'd'))) {
        dispatch(_pageActions2.default.setNearestAvailability(nearestAvailability = null));
      }

      // Prevents unnecessary requests from being made when we already
      // know the nearest availability. Availabilities are only updated
      // again:
      //     - When the user is browsing previous dates and the current
      // start date is the same or before the latest availability found.
      //     - If the current start date is the same day or after the
      // previous nearest availability.
      if (!nearestAvailability || isPreviousDate && props && props.latestAvailabilityFound && (0, _moment2.default)(startDate).startOf('day').isSameOrBefore(props.latestAvailabilityFound)) {
        var specialist = props && props.page && props.page.uri_id || props.params.id;
        var practice = props && props.selectedPractice && props.selectedPractice.id;
        dispatch(_pageActions2.default.loadSpecialistAvailabilities(specialist, {
          startdate: startDate && (0, _moment2.default)(startDate).format('YYYY-MM-DD HH:mm'),
          practice_filter: practice
        })).then(function (response) {
          // Number of days with availabilities.
          var totalDays = response && response.length;

          if (totalDays) {
            dispatch(_pageActions2.default.setLatestAvailabilityFound((0, _moment2.default)(response[totalDays - 1].start_date)));

            if (nearestAvailability) {
              dispatch(_pageActions2.default.setNearestAvailability(null));
            }
          } else if (!nearestAvailability) {
            var nearestAvailabilityStartDate = (0, _moment2.default)(startDate).add((0, _utils.getVisibleCalendarDays)(), 'd');

            dispatch(_pageActions2.default.loadSpecialistAvailabilities(specialist, {
              startdate: nearestAvailabilityStartDate.format('YYYY-MM-DD'),
              enddate: nearestAvailabilityStartDate.clone().add(_constants.NEAREST_AVAILABILITY_END_DAYS, 'd').format('YYYY-MM-DD'),
              practice_filter: practice
            })).then(function (availabilities) {
              dispatch(_pageActions2.default.setNearestAvailability(availabilities && availabilities.length && availabilities[0].start_date || null));
            });
          }
        });
      }
    },
    changeTextButtonClick: function changeTextButtonClick(text) {
      dispatch(_pageActions2.default.changeText(text));
    },
    toggleSection: function toggleSection(toggleValue, sectionName) {
      dispatch(_pageActions2.default.toggleSection(toggleValue, sectionName));
    },
    toggleCalendarView: function toggleCalendarView(view) {
      dispatch(_pageActions2.default.toggleCalendarView(view));
    },
    scrollToReviews: function scrollToReviews() {
      dispatch(_profileRightSection2.default.setSectionActive('Reviews'));
      (0, _doctifyUtils.scrollTo)(document.getElementById('reviews'), document.getElementById('scrolldiv'), SCROLL_DELAY); //eslint-disable
    },
    loginOnSubmit: function loginOnSubmit(data) {
      dispatch((0, _doctifyUtils.authenticateClient)({
        email: data.name,
        password: data.password,
        rememberMe: data.rememberMe
      })).catch(console.error);
    },
    submitBooking: function submitBooking(requestData, auth) {
      return dispatch(_bookAppointmentModal2.default.submitAppointmentRequest(requestData, auth));
    },
    showSignUp: function showSignUp() {
      dispatch(SignUpModalActions.setShouldSetBookingFlowAuthToken(true));
      dispatch(SignUpModalActions.openSignUpModalPatient());
    },
    toggleHospitalListModal: function toggleHospitalListModal(openState) {
      dispatch(_pageActions2.default.toggleModalState(openState));
    },
    chooseHospitalList: function chooseHospitalList(hospitalList) {
      dispatch(_pageActions2.default.chooseHospitalList(hospitalList));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SpecialistPage);


// WEBPACK FOOTER //
// ./components/specialist-page/lib/components/specialist-page.js